import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  // apiKey: "AIzaSyCWJkveDOD2nKMQMU4_ajTo277RmfiWpr8",
  apiKey: "AIzaSyAINuCHY-ZOia7pI-uruYcmrCaAPqha80A",
  authDomain: "react-todo-d5981.firebaseapp.com",
  projectId: "react-todo-d5981",
  storageBucket: "react-todo-d5981.appspot.com",
  messagingSenderId: "987785193923",
  appId: "1:987785193923:web:727aca8cccf52cb7853576",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
